<template>
  <div>
    <div class="text-dark font-size-18 font-weight-bold mb-1">
      Session-Wise Due Breakdown
    </div>
    <div class="text-gray-6 mb-3">
      Overall collection & due breakdown for session <b>{{ selectedSession ? selectedSession.name : '' }}</b>
    </div>
    <div class="chart-container text-center mx-auto" style="position: relative; height: 320px; max-width: 300px;">
      <canvas ref="myChart"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

function formatCompactIndian(num) {
  if (!num || isNaN(num)) return '0'
  if (num >= 10000000) {
    const cr = num / 10000000
    return (cr % 1 === 0 ? cr : cr.toFixed(2)) + 'Cr'
  }
  if (num >= 100000) {
    const lakh = num / 100000
    return (lakh % 1 === 0 ? lakh : lakh.toFixed(2)) + 'L'
  }
  if (num >= 1000) {
    const k = num / 1000
    return (k % 1 === 0 ? k : k.toFixed(1)) + 'k'
  }
  return num.toString()
}

let centerLabel = {
  id: 'centerLabel',
  beforeDraw: function(chart) {
    if (!chart.config.data || !chart.config.data.datasets || !chart.config.data.datasets[0]) return
    const width = chart.chart.width
    const ctx = chart.chart.ctx
    const due = chart.config.data.datasets[0].data[0] || 0
    const paid = chart.config.data.datasets[0].data[1] || 0
    const total = paid + due

    ctx.restore()
    ctx.font = 'bold 13px sans-serif'
    ctx.textBaseline = 'middle'
    ctx.fillStyle = '#111'

    const text = 'Total: ₹' + formatCompactIndian(total)
    const textX = Math.round((width - ctx.measureText(text).width) / 2)

    // Position text in exact center of doughnut inner ring
    const chartArea = chart.chartArea
    const textY = chartArea ? Math.round((chartArea.top + chartArea.bottom) / 2) : Math.round(chart.chart.height / 2)

    ctx.fillText(text, textX, textY)
    ctx.save()
  },
}

export default {
  name: 'SessionWiseDueChart',
  props: {
    reportData: Object,
    selectedSession: Object,
  },
  data: function () {
    return {
      chartInstance: null,
    }
  },
  watch: {
    reportData: {
      immediate: true,
      handler(reportDataLocal) {
        if (!reportDataLocal || !reportDataLocal.overall_session_wise) return
        this.$nextTick(() => {
          this.renderChart(reportDataLocal)
        })
      },
    },
  },
  methods: {
    formatCompactIndian,
    renderChart(reportDataLocal) {
      if (this.chartInstance) {
        this.chartInstance.destroy()
      }
      const totalUnpaidAmount = reportDataLocal.overall_session_wise.overall_total_unpaid_amount || 0
      const totalPaidAmount = reportDataLocal.overall_session_wise.overall_total_paid_amount || 0

      if (!this.$refs.myChart) return

      this.chartInstance = new Chart(this.$refs.myChart, {
        type: 'doughnut',
        data: {
          labels: [
            'Due (₹' + formatCompactIndian(totalUnpaidAmount) + ')',
            'Paid (₹' + formatCompactIndian(totalPaidAmount) + ')',
          ],
          datasets: [{
            backgroundColor: ['#ff4d4f', '#1890ff'],
            hoverBackgroundColor: ['#ff7875', '#40a9ff'],
            data: [totalUnpaidAmount, totalPaidAmount],
            borderWidth: 2,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 70,
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 15,
              fontFamily: 'sans-serif',
              fontSize: 12,
            },
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const dataset = data.datasets[0]
                const val = dataset.data[tooltipItem.index] || 0
                const total = dataset.data.reduce((a, b) => a + b, 0)
                const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0
                const label = tooltipItem.index === 0 ? 'Due' : 'Paid'
                return `${label}: ₹${val.toLocaleString('en-IN')} (${percentage}%)`
              },
            },
          },
        },
        plugins: [centerLabel],
      })
    },
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
}
</script>
